module.exports = __webpack_public_path__ + "static/img/icon_medal_normal.3dc72735.svg";